module.exports = __webpack_public_path__ + "img/6600.3aece142.jpg";